import styled from "@emotion/styled";
import { Avatar } from "@mui/material";

export const AvatarStyle = styled(Avatar)``;
